import React from 'react';
import styled from '@emotion/styled';
import { colors, mixins } from '../../core/styles/theme/default';
import { rem } from 'polished';
import { Helmet as ReactHelmet } from 'react-helmet';
import Spacer from '../../helpers/Spacer';

const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 0 ${rem(-8)};
  display: flex;
  flex-wrap: wrap;

  li {
    ${mixins.responsiveStyles({
      'font-size': { zero: `${rem(12)}`, medium: `${rem(14)}` },
      'line-height': { zero: `${rem(18)}`, medium: `${rem(20)}` },
    })}

    &:not(:last-child) {
      &::after {
        content: '/';
        color: ${colors.nightBlue300};

        ${mixins.responsiveStyles({
          margin: { zero: `0 ${rem(4)}`, medium: `0 ${rem(8)}` },
        })}
      }
    }

    a {
      color: ${colors.nightBlue700};
      font-weight: 500;
      display: inline-block;
      min-width: ${rem(44)};
      padding: ${rem(8)};
    }
  }

  ${({ theme }) => theme?.stylesExtension?.breadcrumb}
`;

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  return (
    <>
      <ReactHelmet>
        <script type="application/ld+json">
          {`{
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [${items.map(
                (
                  {
                    href,
                    title,
                  }: {
                    href: string;
                    title: string;
                  },
                  index: number,
                ) =>
                  `{
                    "@type": "ListItem",
                    "position": ${index + 1},
                    "name": "${title}"
                    ${
                      index + 1 !== items.length
                        ? `
                    ,"item": "${href}"
                    `
                        : ``
                    }
                  }`,
              )}]
          }`}
        </script>
      </ReactHelmet>
      <StyledList>
        {items.map(({ href, title }: { href: string; title: string }) => (
          <li key={href}>
            <a href={href}>{title}</a>
          </li>
        ))}
      </StyledList>
      <Spacer space="gamma" />
    </>
  );
};

export type BreadcrumbProps = {
  items: {
    title: string;
    href: string;
  }[];
};

export default Breadcrumb;
